const COUNT_DURATION = 1500;
const COUNT_START_DELAY = 900;

function animateCount(element: HTMLElement): void {
	const target = Number(element.dataset.countTo);
	const suffix = element.dataset.countSuffix || '';

	if (!Number.isFinite(target)) return;

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		element.textContent = `${target}${suffix}`;
		return;
	}

	function startAnimation(): void {
		const startTime = performance.now();

		function update(currentTime: number): void {
			const progress = Math.min((currentTime - startTime) / COUNT_DURATION, 1);
			const currentValue = progress < 1
				? Math.floor(target * progress)
				: target;

			element.textContent = `${currentValue}${suffix}`;

			if (progress < 1) {
				requestAnimationFrame(update);
			}
		}

		requestAnimationFrame(update);
	}

	window.setTimeout(startAnimation, COUNT_START_DELAY);
}

export function initCountUp(): void {
	const intro = document.getElementById('intro');
	if (!intro) return;

	const counters = intro.querySelectorAll<HTMLElement>('[data-count-to]');
	if (!counters.length) return;

	counters.forEach(counter => {
		counter.textContent = `0${counter.dataset.countSuffix || ''}`;
	});

	const observer = new IntersectionObserver((entries) => {
		if (!entries.some(entry => entry.isIntersecting)) return;

		counters.forEach(animateCount);
		observer.disconnect();
	}, {
		threshold: 0.25,
	});

	observer.observe(intro);
}
